import { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { NavLink } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import Logo from "../../assets/imagens/sobre/logoteste.png";
import "./style.css";

const WHATSAPP_RESERVA =
  "https://wa.me/5542933008907?text=Ol%C3%A1!%20Gostaria%20de%20reservar%20no%20Hotel%20Marechal%20Express.";

const navLinkClass = ({ isActive }) =>
  "nav-link-hotel align-self-lg-center" + (isActive ? " nav-link-hotel--active" : "");

function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <Navbar
      variant="dark"
      expand="lg"
      data-bs-theme="dark"
      className={`navbar-hotel fixed-top${scrolled ? " navbar-hotel--scrolled" : ""}`}
    >
      <Container fluid="xxl" className="px-3 px-lg-4">
        <Navbar.Brand as={NavLink} to="/" className="navbar-brand-hotel py-0 me-lg-4">
          <img
            className="img-fluid navbar-brand-hotel__logo"
            src={Logo}
            alt="Hotel Marechal Express"
          />
        </Navbar.Brand>
        <div className="d-flex align-items-center gap-2 ms-auto ms-lg-0 order-lg-last">
          <Nav.Link
            href={WHATSAPP_RESERVA}
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link-cta d-none d-sm-inline-flex"
          >
            <FaWhatsapp className="nav-link-cta__icon" aria-hidden />
            Reservar
          </Nav.Link>
          <Navbar.Toggle
            className="navbar-hotel__toggle"
            aria-controls="hotel-navbar"
            aria-label="Abrir menu"
          />
        </div>
        <Navbar.Collapse id="hotel-navbar">
          <Nav className="ms-auto gap-lg-1 align-items-lg-center">
            <Nav.Link as={NavLink} to="/" end className={navLinkClass}>
              Início
            </Nav.Link>
            <Nav.Link as={NavLink} to="/acomodações" className={navLinkClass}>
              Acomodações
            </Nav.Link>
            <Nav.Link as={NavLink} to="/estrutura" className={navLinkClass}>
              Estrutura
            </Nav.Link>
            <Nav.Link as={NavLink} to="/localizacao" className={navLinkClass}>
              Localização
            </Nav.Link>
            <Nav.Link as={NavLink} to="/termos" className={navLinkClass}>
              Termos
            </Nav.Link>
            <Nav.Link
              href="tel:+554236352720"
              className="nav-link-hotel nav-link-hotel--phone align-self-lg-center d-none d-lg-inline-flex"
            >
              (42) 3635-2720
            </Nav.Link>
            <Nav.Link
              href={WHATSAPP_RESERVA}
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link-cta nav-link-cta--mobile d-sm-none w-100 mt-2 justify-content-center"
            >
              <FaWhatsapp className="nav-link-cta__icon" aria-hidden />
              Reservar no WhatsApp
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
